module.exports = __webpack_public_path__ + "static/media/car_header_b.d6248930.svg";